<template>
    <div>
        <button @click="checkJoinRequestPayAvailable" style="margin-top:20px;padding:10px;">결제 가능 여부 체크</button>

        <button @click="saveDirectMessageTemporaliy" style="margin-top:20px;padding:10px;">임시 다이렉트 메시지 남기기</button>

        <button @click="checkPaid" style="margin-top:20px;padding:10px;">결제 완료 여부 체크</button>
    </div>
</template>

<script>
import ResponseCode from "../../../ResponseCode";

export default {
    name: "TestRequestPay",
    data() {
        return {
            amt: 1000,
            team: {
                idx: 1,
                manager: {
                    idx: 349362
                }
            },
            phone: '010-5138-3247'
        }
    },
    methods: {
        async checkJoinRequestPayAvailable() {
            const res = await this.$Axios.get('/api/pay/request/join/check');
            console.log(res.data);
            const code = res.data.code;
            if (code === ResponseCode.SUCCESS) {
                console.log('결제창');
                this.showPayment();
                //가족 결제부터
            } else if (code === 1) {
                console.log('가족 결제창');
                // this.saveDirectMessageTemporaliy()
                //가족 등록부터
            } else if (code === 2) {
                console.log('가족 등록창')
            }
        },
        showPayment() {
            if (!this.$Util.checkLogin()) return;
            this.$GlobalStore.addModal('Payment', { payAction: this.payAction, goods_name: '다이렉트 요청서 보내기', amt: this.amt });
        },
        async payAction(pay_method, pay_mode, card_idx) {
            const parameters = {};
            parameters.pay_mode = pay_mode;
            // amt 실제결제금액
            parameters.amt = this.amt;
            parameters.goods_name = '다이렉트 요청서 보내기';
            parameters.card_idx = card_idx;
            // 해당되는 idx
            parameters.to_member_idx = this.team.manager.idx;
            parameters.team_idx = this.team.idx;

            await this.$Util.payIntegrated(pay_method, parameters, async (converted_parameters) => {
                return await this.$Axios.post('/api/pay/direct/message/save', converted_parameters);
            }, async (converted_parameters) => {
                const res = await this.$Axios.post('/api/pay/direct/message/save', converted_parameters);
                if (res.data.code === ResponseCode.SUCCESS) {
                    this.$GlobalStore.closeLastModal();
                } else if (res.data.code === ResponseCode.FAIL) {
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            }, async () => {
                // TODO {refer_idx} 에 soccerhow_idx 넣어주기
                return [true, { refer_idx: 10 }];
            })
        },
        async saveDirectMessageTemporaliy() {
            const parameters = {};
            parameters.team_idx = this.team.idx;
            parameters.to_member_idx = this.team.manager.idx;
            parameters.refer_idx = 10;
            parameters.phone = this.phone;
            const res = await this.$Axios.post('/api/pay/direct/message/save/temp', parameters);
            if (res.data.code === ResponseCode.SUCCESS) {
                res.data.direct_message_idx;
                console.log('저장완료 후 기다림')
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg)
            }
        },
        //5초에 한번씩 호출.
        async checkPaid() {
            const parameters = {};
            parameters.direct_message_idx = 78;
            const res = await this.$Axios.get('/api/pay/direct/message/wait', {params : parameters});
            if (res.data.code === ResponseCode.SUCCESS) {
                console.log('결제됨. 다음 화면으로')
            } else if (res.data.code === ResponseCode.FAIL) {
                this.$GlobalStore.showAlert(res.data.msg)
            }

        }

    }
}
</script>

<style scoped></style>